import { createContext, useContext } from 'react';

export type ToastTone = 'info' | 'success' | 'warning' | 'error';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastOptions {
  tone?: ToastTone;
  /** Optional bold line above the message. */
  title?: string;
  /** Milliseconds. `0` keeps the toast until it is dismissed. */
  duration?: number;
  action?: ToastAction;
}

export interface ToastRecord {
  readonly id: string;
  readonly message: string;
  readonly tone: ToastTone;
  readonly title?: string;
  readonly duration: number;
  readonly action?: ToastAction;
}

export interface ToastApi {
  /** Shows a toast and returns its id. */
  show: (message: string, options?: ToastOptions) => string;
  dismiss: (id: string) => void;
  dismissAll: () => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (api === null) {
    throw new Error('useToast must be called inside a <ToastProvider>.');
  }
  return api;
}
